import comp from "./ImageCarousel";
export default comp;
